module.exports = __webpack_public_path__ + "media/images/aloe/illustrations/bed-329a2554da2685db526346582b4c36b8.svg";